import { ReactNode } from "react";
import * as React from "react";
import { observer } from "mobx-react";

import { ProductsWrap, GridMoreBaseBox } from "./styles";
import Loading from "../../components/Loading";
import ScrollLoad from "../../components/ScrollLoad";
import { ProductCard } from "./ProductCard";
import ProductTags from "./ProductTags";

import ProductStore from "./store";
import { isNotBlankArray } from "utils/array";
import { TProductElement, TProductBaseProps } from "../../../services/product";
import { TTagModule } from "../../../services/playground";
import {
	transformGridWidth2Number,
	getCellWidthByGrid as getProductCardPosterWidth,
} from "../../utils/size";
import { ModuleLayoutStyle } from "../../../services/playground";
import { isInWindowView, returnProductIndex } from "utils/browser";

export type WebProductsProps = TProductBaseProps & {
	posterRatio?: number;
	originPriceBr?: Boolean;
};
export interface WebProductsState {
	activeTab: string;
	activeTabIndex: number;
	isChangeTab: boolean;
	showedProducts: TProductElement[];
}
@observer
class WebProducts extends React.Component<WebProductsProps, WebProductsState> {
	private contentRef: React.RefObject<HTMLDivElement> = React.createRef();

	productStore: ProductStore;
	hasListener: boolean = false;
	scrollEndTimer: NodeJS.Timeout;
	scrollTop: number = 0;
	// preProductIndex: number = 0;

	static defaultProps = {
		stickToTop: 0,
		productModules: [],
		layout: {
			gap: 12,
			columnNum: 4,
		},
	};

	constructor(props: WebProductsProps) {
		super(props);
		this.productStore = new ProductStore(props.productModules);
		const activeTab = props.activeTab || props.productModules[0]?.poolId;
		this.state = {
			activeTab,
			isChangeTab: false,
			activeTabIndex: Math.max(0, props.activeTabIndex || 0),
			showedProducts: this.productStore.productsListMap[activeTab] || [],
		};
	}

	componentDidMount() {
		window.addEventListener("scroll", this.onScroll);
		this.trackOnShow();
	}
	componentWillUnmount() {
		window.removeEventListener("scroll", this.onScroll);
	}

	onScroll = () => {
		clearTimeout(this.scrollEndTimer);
		this.scrollEndTimer = setTimeout(this.isScrollEnd, 600);
		this.scrollTop = window.scrollY || window.pageYOffset;
	};
	isScrollEnd = () => {
		const endTop = window.scrollY || window.pageYOffset;
		const placeHolderCurrent = this.contentRef.current as HTMLElement;
		if (endTop === this.scrollTop && isInWindowView(placeHolderCurrent)) {
			this.trackOnShow();
		}
	};
	trackOnShow = () => {
		const { SetCtrTrackOnShow, SetGtmTrackOnShow } = this.props;
		const { showedProducts, activeTab } = this.state;
		const { handleExposureProductList, exposureProductListMap, productsListMap } =
			this.productStore;
		let exposureProducts = exposureProductListMap[activeTab] || null;
		const productList = productsListMap[activeTab];
		if (showedProducts.length > 0 && (SetCtrTrackOnShow || SetGtmTrackOnShow)) {
			const posArr: number[] = [];
			const pidsArr: string[] = [];
			let exportArr: string[] = [];
			showedProducts.forEach((item) => {
				const showItemHtml = document.getElementById(`${activeTab}${item.gpid}`);
				let exposureItem = null;
				const productIndex = returnProductIndex(item.gpid, productList);
				if (exposureProducts) {
					exposureItem = exposureProducts.find((it) => it === item.gpid);
					exportArr = exposureProducts;
				}
				if (showItemHtml && isInWindowView(showItemHtml) && !exposureItem && productIndex) {
					posArr.push(productIndex);
					pidsArr.push(item.gpid);
					exportArr.push(item.gpid);
				}
			});
			// 记录已上报的产品gpid
			exposureProducts = exportArr;
			posArr.length > 0 && SetCtrTrackOnShow && SetCtrTrackOnShow(posArr.join(","), pidsArr);
			posArr.length > 0 && SetGtmTrackOnShow && SetGtmTrackOnShow(showedProducts, posArr);
			// this.preProductIndex = this.preProductIndex + showedProducts.length;
			// this.setState({ showedProducts: [] });
			posArr.length > 0 && handleExposureProductList(activeTab, exposureProducts);
		}
	};

	productCardWidth = (): number => {
		const { layout, width, minWidth } = this.props;
		const { gap = 12, columnNum = 4 } = layout;
		const contentWidth = transformGridWidth2Number(width || 1200, minWidth);

		return getProductCardPosterWidth({
			contentWidth,
			gridCol: columnNum,
			gridGap: gap,
		});
	};

	onTagsChange = async (category: TTagModule, index: number, fixed: boolean) => {
		if (this.props.onClickTab) {
			this.props.onClickTab(index);
		}
		this.setState({
			activeTab: category.id,
			showedProducts: [],
			activeTabIndex: index,
		});
		if (!isNotBlankArray(this.productStore.productsListMap[category.id])) {
			this.setState({
				isChangeTab: true,
			});
			await this.onLoadMoreProducts(category.id)();
			if (category.id) {
				this.setState({
					isChangeTab: false,
				});
			}
			// this.preProductIndex = 0;
		}

		/* scroll to top */
		if (fixed) {
			const offsetTop = this.contentRef?.current?.offsetTop || 0;
			const { stickToTop = 0 } = this.props;
			window.scrollTo(0, offsetTop - stickToTop);
		} else {
			this.trackOnShow();
		}
	};

	onLoadMoreProducts = (poolId: string) => async () => {
		if (poolId) {
			const nextProducts =
				(await this.productStore.loadProductsList(poolId, this.props.onLoadPool)) || [];
			this.productStore.productsListMap[poolId];
			this.setState({
				showedProducts: [...this.state.showedProducts, ...nextProducts],
			});
		}
	};
	onClickProduct = (post: string, pid: string) => {
		this.props.SetCtrTrackOnAction && this.props.SetCtrTrackOnAction(post, pid);
	};

	renderList = (poolId: string): ReactNode => {
		const { layout, posterRatio, placeholderBg, scoreOptions, smartImageProps, originPriceBr } = this.props;
		const { columnNum = 4 } = layout;
		const productCardWidth = this.productCardWidth();

		const { productsListMap = {} } = this.productStore;
		const products: TProductElement[] = productsListMap[poolId];
		if (!products) {
			return null;
		}
		return products.map((item, index) => {
			return (
				<ProductCard
					key={index}
					product={{ ...item }}
					width={`${productCardWidth}px`}
					posterRatio={posterRatio}
					gridCol={columnNum}
					placeholderBg={placeholderBg}
					collectOptions={scoreOptions}
					smartImageProps={smartImageProps}
					onClick={() => this.onClickProduct((index + 1).toString(), item.gpid)}
					layoutStyle={this.props.layoutStyle || ModuleLayoutStyle.Orange}
					poolId={poolId}
					originPriceBr={originPriceBr}
				/>
			);
		});
	};

	renderBody = () => {
		const { layout } = this.props;
		const { gap = 12, columnNum = 4 } = layout;
		const { isChangeTab, activeTab: poolId } = this.state;
		const loading = poolId ? this.productStore.isLoadingProducts[poolId] : false;
		if (isChangeTab) {
			return <Loading />;
		}

		return (
			<>
				<GridMoreBaseBox gridCol={columnNum} gridGap={gap} width={this.productCardWidth()}>
					{this.renderList(poolId)}
				</GridMoreBaseBox>
				{loading && <Loading />}
			</>
		);
	};

	render() {
		const {
			stickToTop,
			positionId = "",
			tagGroup = [],
			canScrollFixed,
			width = "",
		} = this.props;
		const { activeTab, activeTabIndex } = this.state;

		return (
			<ProductsWrap id={positionId} gridWidth={+width} ref={this.contentRef}>
				{isNotBlankArray(tagGroup) && (
					<ProductTags
						stickToTop={stickToTop}
						key={positionId}
						canScrollFixed={canScrollFixed}
						onChange={this.onTagsChange}
						activeTab={activeTab}
						activeTabIndex={activeTabIndex}
						tagGroup={tagGroup}
						width={this.props.width}
					/>
				)}

				<ScrollLoad
					onLoadMore={this.onLoadMoreProducts(activeTab)}
					targetRef={this.contentRef}
				>
					{this.renderBody()}
				</ScrollLoad>
			</ProductsWrap>
		);
	}
}

export default function ProductExposed(props: WebProductsProps) {
	return (
		<>
			<WebProducts {...props} />
		</>
	);
}
